<script lang="ts">
  import { browser } from '$app/env';
  import PageTitle from '$lib/teach/resources/PageTitle.svelte';

  import PitchyFish from 'exercises/src/uTheory.Interaction/PitchyFish/PitchyFish.svelte';
</script>

<PageTitle
  title="Pitchy Fish"
  description="A flappy bird clone for singing. Guide the fish between gaps in piers by singing higher and lower."
  seoImageUrl="/assets/pitchy-fish/pitchy-fish-seo-image-2.jpg"
  seoImageAlt="An image from the Pitchy Fish game, of a fish swimming between gaps in piers, controlled by singing higher and lower."
  seoImageHeight={3000}
  seoImageWidth={3000}
/>

{#if browser}
  <PitchyFish />
{/if}
